import { EChartsCoreOption } from './echartsCore';
import { TOOLTIP_BASE } from './tooltipAdapter';
import { HORIZONTAL_BAR_END_RADIUS } from './barStyle';

export interface CategoryBar {
    name: string;
    value: number;
    color?: string;
}

export interface CategoryBarOptionArgs {
    bars: CategoryBar[];
    seriesName?: string;
}

export const buildCategoryBarOption = (args: CategoryBarOptionArgs): EChartsCoreOption => {
    const ordered = args.bars.slice().reverse();

    return {
        animation: false,
        grid: { left: 8, right: 48, top: 8, bottom: 8, containLabel: true },
        xAxis: {
            type: 'value',
            min: 0,
            splitLine: { show: true },
            axisLabel: { fontSize: 11 },
        },
        yAxis: {
            type: 'category',
            data: ordered.map(bar => bar.name),
            axisTick: { show: false },
            axisLabel: { fontSize: 11 },
        },
        tooltip: {
            ...TOOLTIP_BASE,
            trigger: 'item',
            formatter: (params: unknown) => {
                const point = params as { name?: string; value?: number };
                return `<div class="chart-tooltip-new"><b>${point.name ?? ''}</b>: ${point.value ?? 0}</div>`;
            },
        },
        legend: { show: false },
        series: [{
            type: 'bar',
            name: args.seriesName,
            itemStyle: { borderRadius: HORIZONTAL_BAR_END_RADIUS },
            label: { show: true, position: 'right', fontSize: 11 },
            data: ordered.map(bar => ({
                value: bar.value,
                ...(bar.color ? { itemStyle: { color: bar.color } } : {}),
            })),
        }],
    };
};
